export const CSV_DELIMITERS = [',', ';'];
